import { Card, CardFooter, FadeContent, FadeWrapper } from 'components/common';
import CustomScrollbar from 'components/common/CustomScrollbar';
import { CommonLink } from 'components/common/Forms/Button';
import { CardLoader } from 'components/common/Loading';
import ContactUs from 'components/views-components/un-auth/Support/ContactUs';
import { ReadOnlyQuill } from 'components/WYSIWYG/ReadOnlyQuill';
import { QuillPreview } from 'components/WYSIWYG/WYSIWYG.styled';
import { PatientLayout } from 'containers/PatientLayout';
import { useAuth } from 'context/AuthContext';
import { ReactElement } from 'react';
import { useSupportTemplate } from 'query/storage';
import { useSiteBooleanAttributes } from 'hooks/useAttribute';
import { SHOW_PATIENT_SUPPORT_FORM } from 'configs/siteAndTrustAttributes';
import { PageHelmet } from 'components/common/PageHelmet';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';

export default function SupportPage(): ReactElement {
  const { sangixUser } = useAuth();
  const { t } = useCommonTranslation();
  const [showPatientSupportForm] = useSiteBooleanAttributes(
    SHOW_PATIENT_SUPPORT_FORM,
  );

  const { isLoading, data } = useSupportTemplate();
  const content = data?.data;

  return (
    <PatientLayout graphics={Boolean(sangixUser) ? 'patient' : 'unauth'}>
      <PageHelmet title={t('support')} />
      <Card fade>
        <FadeWrapper>
          <CustomScrollbar
            style={{ width: '100%' }}
            autoHeight
            autoHeightMin={'100%'}
            autoHeightMax={'100%'}
          >
            <FadeContent>
              {isLoading && !Boolean(content) ? (
                <CardLoader />
              ) : (
                <QuillPreview>
                  <ReadOnlyQuill value={content as string} />
                </QuillPreview>
              )}
              {(!sangixUser || showPatientSupportForm) && <ContactUs />}
            </FadeContent>
          </CustomScrollbar>
        </FadeWrapper>
        <CardFooter>
          <CommonLink to="/" variant="secondary">
            {Boolean(sangixUser) ? 'Back to Menu' : 'Back to Login'}
          </CommonLink>
        </CardFooter>
      </Card>
    </PatientLayout>
  );
}
